import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Language } from '../App';
interface LegalProps {
  language: Language;
}
const content = {
  en: {
    title: 'Professional Medical Practice',
    text: 'Dermalipo operates as a professional medical practice under the laws of New York State. All physicians are licensed to practice medicine in New York. Our practice complies with all applicable state and federal regulations, including HIPAA privacy requirements. Medical services are provided by appointment only. This website does not constitute medical advice and is for informational purposes only.'
  },
  es: {
    title: 'Práctica Médica Profesional',
    text: 'Dermalipo opera como una práctica médica profesional bajo las leyes del Estado de Nueva York. Todos los médicos tienen licencia para ejercer la medicina en Nueva York. Nuestra práctica cumple con todas las regulaciones estatales y federales aplicables, incluidos los requisitos de privacidad de HIPAA. Los servicios médicos se brindan solo con cita previa. Este sitio web no constituye consejo médico y es solo para fines informativos.'
  }
};
export function Legal({
  language
}: LegalProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const t = content[language];
  return <section ref={ref} className="py-16 px-4 sm:px-6 lg:px-8 bg-brown-dark/50" data-id="element-128">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto text-center space-y-4" data-id="element-129">
        <h3 className="text-2xl font-bold text-pearl" data-id="element-130">{t.title}</h3>
        <p className="text-pearl/60 text-sm leading-relaxed" data-id="element-131">{t.text}</p>
      </motion.div>
    </section>;
}